// extracted by mini-css-extract-plugin
module.exports = {"registration_main":"Theme12_registration_main__wum1l","change_email":"Theme12_change_email__x63Fa"};